const initialState = {
  styleSelectorShown: null,
};

const Actions = {
  STYLE_SELECTOR_SHOWN_CHANGED: 'ui/style-selector-shown-changed',
};

const styleSelectorShownChanged = (styleSelectorShown) => ({
  type: Actions.STYLE_SELECTOR_SHOWN_CHANGED,
  styleSelectorShown,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.STYLE_SELECTOR_SHOWN_CHANGED:
      return {
        ...state,
        styleSelectorShown: action.styleSelectorShown,
      };
  }

  return state;
};

const selectStyleSelectorShown = (state) => state.ui.styleSelectorShown;

export { reducer, styleSelectorShownChanged, selectStyleSelectorShown };
